import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { BehaviorSubject, Observer } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TicketService } from "../../../services/ticket.service";
import { AuthService } from "../../../auth.service";
import { NavigationEnd, Router } from "@angular/router";
import { Messages } from "../../../model/messages";
import { ActionButtonSubmit } from "../../../model/action-button-submit";
import { Ticket } from "../../../model/ticket";
import { NavigationHelper } from "../../../services/navigation.helper";
import { Navigation } from "../../../model/navigation";
import { SingleChoice } from "../../../model/singlechoice";
import { BranchService } from "../../../services/branch.service";

import { StatusService } from "../../../services/status.service";
import { PrioritiesService } from "../../../services/priorities.service";
import { DepartmentsService } from "../../../services/departaments.service";
import { UsersService } from "../../../services/users.service";
import { DependentChoice } from "../../../model/dependentchoice";
import { DomSanitizer } from "@angular/platform-browser";

import { Comment } from "../../../model/comments";
import { Task } from "../../../model/task";
import { Involved } from "../../../model/involved";
import { Media } from "../../../model/media";
import { Labeler } from "../../../model/labeler";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { animate, style, transition, trigger } from "@angular/animations";
import { CommentsComponent } from "../../comments/comments.component";
import { MediaListComponent } from "../../media-list/media-list.component";
import { TimeLine } from "../../../model/time-line";
import { CommentsService } from "../../../services/comments.service";
import { InvolvedService } from "../../../services/involved.service";
import { environment } from "../../../../environments/environment";
import { InvolvedComponent } from "../../involved/involved/involved.component";

@Component({
  selector: "ticket-details",
  templateUrl: "./ticket-details.component.html",
  styleUrls: ["./ticket-details.component.css"],
  animations: [
    trigger("tabSlide", [
      transition("void => next", [
        style({ transform: "translateX(100%)" }),
        animate("300ms ease-out", style({ transform: "translateX(0%)" })),
      ]),
      transition("void => prev", [
        style({ transform: "translateX(-100%)" }),
        animate("300ms ease-out", style({ transform: "translateX(0%)" })),
      ]),
      transition("* => void", [
        animate("300ms ease-in", style({ transform: "translateX(-100%)" })),
      ]),
    ]),
  ],
})
export class TicketDetailsComponent implements OnInit {
  @Output() choiceEvent: EventEmitter<SingleChoice> = new EventEmitter();
  @Output() dependentEvent: EventEmitter<DependentChoice> = new EventEmitter();
  messages = new BehaviorSubject<Messages>(Messages.EMPTY);
  ticket = new BehaviorSubject<Ticket>(Ticket.EMPTY);
  branchLabeler = new BehaviorSubject<string>("-");
  statusLabeler = new BehaviorSubject<string>("-");
  priorityLabeler = new BehaviorSubject<string>("-");
  departmentLabeler = new BehaviorSubject<string>("-");
  assignedLabeler = new BehaviorSubject<string>("-");
  completionUrl = new BehaviorSubject<string>("");
  ticketForm: FormGroup;
  ticketTitle: string = "ticketDetails.title.exist.ticket";

  isLoading: boolean = false;

  commentsVisible: boolean = false;
  comments = new BehaviorSubject<Comment[]>([]);
  timelineVisible: boolean = false;

  involvedVisible: boolean = false;
  involveds = new BehaviorSubject<Involved[]>([]);
  mediaVisible: boolean = false;
  media = new BehaviorSubject<Media[]>([]);
  tasks = new BehaviorSubject<Task>(Task.EMPTY);
  iconMap: { [key: string]: string } = {
    status: "hourglass_empty",
    priority: "priority_high",
    department: "domain",
  };
  ticketBackup: Ticket | null = null;
  stateGuard: boolean;
  disableEditingDuringChoice: boolean = false;
  createMode: boolean = true;
  editMode: boolean = false;
  isCreating: boolean = true;
  selectedIndex = 0;
  previousIndex = 0;
  @ViewChild(CommentsComponent) commentsComponent: CommentsComponent;
  @ViewChild(MediaListComponent) mediaComponent: MediaListComponent;
  @ViewChild(InvolvedComponent) involvedComponent: InvolvedComponent;
  @Input() items: any[] = [];
  firstLoad = true;
  tabs = [
    { label: "Comments", icon: "fas fa-comment" },
    { label: "Media", icon: "fas fa-photo-video" },
    { label: "Involved", icon: "fas fa-user-friends" },
    ...(environment.environment === "dev"
      ? [{ label: "Timeline", icon: "fas fa-stream" }]
      : []),
  ];

  showCopied = false;
  public timelineView = new BehaviorSubject<TimeLine[]>([]);
  appBaseUrl: string;
  constructor(
    private ticketService: TicketService,
    private auth: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private nav: NavigationHelper,
    private branches: BranchService,
    private status: StatusService,
    private priority: PrioritiesService,
    private department: DepartmentsService,
    private assigned: UsersService,
    private sanitizer: DomSanitizer,
    private commentsService: CommentsService,
    private involvedService: InvolvedService
  ) {
    this.appBaseUrl = environment.APP_BASE_URL;
  }

  ngOnInit(): void {
    this.initializeForm();

    this.updateEditModeFromUrl(this.router.url);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateEditModeFromUrl(this.router.url);
        this.editOrNot();
      }
    });

    const savedTabIndex = localStorage.getItem("ticketDetailsSelectedTab");
    if (savedTabIndex !== null) {
      this.selectedIndex = +savedTabIndex;
      this.previousIndex = 0;
      this.onTabChange(this.selectedIndex);
    }

    const restoredState = this.ticketService.restoreFormState();

    this.ticketForm.valueChanges.subscribe((formValue) => {
      if (this.stateGuard) {
      } else if (this.disableEditingDuringChoice) {
      } else if (this.editMode) {
        this.stateGuard = true;
        this.ticketService.setFormState(formValue);
        this.stateGuard = false;
      }
    });

    this.ticketService.formState.subscribe((restoredState) => {
      if (this.stateGuard) {
      } else if (this.editMode) {
        this.restoreFormValues(restoredState);
        this.editOrNot();
      }
    });

    this.ticket.subscribe(() => {
      this.branchLabeler.next(this.branchLabel);
      this.statusLabeler.next(this.statusLabel);
      this.priorityLabeler.next(this.priorityLabel);
      this.departmentLabeler.next(this.departmentLabel);
      this.assignedLabeler.next(this.assignedLabel);
    });

    this.ticketService.selectedTicketObservable.subscribe((selectedTicket) => {
      if (selectedTicket?.id != null) {
        this.isCreating = selectedTicket.id === -9;

        if (!this.disableEditingDuringChoice) {
          this.ticket.next(Ticket.EMPTY);

          this.ticket.next(selectedTicket);
          this.populateForm(selectedTicket);
          this.updateTimelineView(selectedTicket);

          const fullTicket = this.ticketService.currentTicket;

          this.comments.next(fullTicket.parts?.comments ?? []);
          this.involveds.next(fullTicket.parts?.ticketInvolved ?? []);
          this.media.next(fullTicket.parts?.media ?? []);
        }
      }
    });

    if (!this.ticketService.currentTicket?.id) {
      this.ticketService.selectFromRouter();
    }

    this.nav.fragmentTopics.subscribe((topic) => {
      if (topic === "comment") {
        this.showComments();
      } else if (topic === "involved") {
        this.showInvolved();
      } else if (topic === "media") {
        this.showMedia();
      } else if (topic === "timeline") {
        this.selectTab(0);
      }
    });

    localStorage.removeItem("ticketDetailsSelectedTab");
  }

  private updateEditModeFromUrl(url: string): void {
    if (url.includes("/edit")) {
      this.editMode = true;
      this.ticketTitle = "ticketDetails.title.exist.ticket";
    } else if (/^\/tickets\/\d+(\/)?$/.test(url)) {
      this.editMode = false;
      this.ticketTitle = "ticketDetails.title.exist.ticket";
    }
  }

  restoreFormValues(restoredState: Partial<Ticket>) {
    if (!this.disableEditingDuringChoice) {
      if (Object.keys(restoredState).length > 0) {
        this.populateForm(restoredState as Ticket);
      }
    }
  }
  copyIdToClipboard(): void {
    const id = this.ticket.value.id;
    if (id) {
      navigator.clipboard.writeText(id.toString()).then(() => {});
      this.showCopied = true;

      setTimeout(() => {
        this.showCopied = false;
      }, 2000);
    }
  }

  copyOnly(event: MouseEvent, link: string) {
    event.preventDefault();
    navigator.clipboard.writeText(link);
    this.showCopied = true;

    setTimeout(() => {
      this.showCopied = false;
    }, 2000);
  }

  sanitizeHtml(html: string): string {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  getDirection(i: number): string {
    if (this.selectedIndex === i) {
      return this.selectedIndex > this.previousIndex ? "next" : "prev";
    }
    return "void";
  }
  selectTab(index: number) {
    if (index !== this.selectedIndex) {
      this.previousIndex = this.selectedIndex;
      this.selectedIndex = index;
    }
  }

  onTabChange(index: number) {
    this.selectedIndex = index;
    localStorage.setItem("ticketDetailsSelectedTab", index.toString());
    this.selectTab(index);

    const label = this.tabs[index].label.toLowerCase();

    switch (label) {
      case "comments":
        setTimeout(() => this.commentsComponent?.createComment());
        this.showComments();
        break;
      case "involved":
        setTimeout(() => this.involvedComponent?.createInvolved());
        this.showInvolved();
        break;
      case "media":
        setTimeout(() => this.mediaComponent?.createMedia());
        this.showMedia();
        break;
      case "timeline":
        this.showTimeline();
        break;
    }
  }

  showTimeline() {
    if (environment.environment !== "dev") return;

    this.timelineVisible = true;
    this.commentsVisible = false;
    this.involvedVisible = false;
    this.mediaVisible = false;

    setTimeout(() => {
      const timelineSection = document.getElementById("timeline-section");
      timelineSection?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  toggleTimeline() {
    this.timelineVisible = !this.timelineVisible;
    if (this.timelineVisible) {
      const ticketId = this.ticketId;
      this.router.navigate([`tickets/${ticketId}/fragment/timeline`]);
      this.commentsVisible = false;
      this.involvedVisible = false;
      this.mediaVisible = false;
      this.showTimeline();
    }
  }

  toggleComments() {
    if (!this.commentsVisible) {
      this.commentsVisible = true;
      this.createMode = true;
      const ticketId = this.ticketId;

      this.router.navigate([`tickets/${ticketId}/fragmentedit`], {
        fragment: "comment",
      });
      this.nav.freshNavigation;

      this.commentsComponent?.createComment();

      this.showComments();
    }
  }

  showComments() {
    this.commentsVisible = true;
    this.timelineVisible = false;
    this.involvedVisible = false;
    this.mediaVisible = false;

    setTimeout(() => {
      const commentsSection = document.getElementById("comments-section");

      commentsSection?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  toggleInvolved() {
    this.involvedVisible = !this.involvedVisible;
    if (this.involvedVisible) {
      const ticketId = this.ticketId;
      this.router.navigate([`tickets/${ticketId}/fragment/involved`]);
      this.timelineVisible = false;
      this.commentsVisible = false;
      this.mediaVisible = false;
      this.showInvolved();
    }
  }

  showInvolved() {
    this.involvedVisible = true;
    this.timelineVisible = false;
    this.commentsVisible = false;
    this.mediaVisible = false;
    setTimeout(() => {
      const involvedSection = document.getElementById("involved-section");
      involvedSection?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  }
  toggleMedia() {
    this.mediaVisible = !this.mediaVisible;
    if (this.mediaVisible) {
      const ticketId = this.ticketId;
      this.router.navigate([`tickets/${ticketId}/fragment/media`]);
      this.timelineVisible = false;
      this.commentsVisible = false;
      this.involvedVisible = false;
      this.showMedia();
    }
  }
  showMedia() {
    this.mediaVisible = true;
    this.timelineVisible = false;
    this.commentsVisible = false;
    this.involvedVisible = false;
    setTimeout(() => {
      const mediaSection = document.getElementById("media-section");
      mediaSection?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }
  private editOrNot(reset: boolean = false) {
    var nav = this.nav.current;
    if (Navigation.NEW.toString() === nav.id) {
      this.editMode = true;
      this.ticketTitle = "ticketDetails.title.new.ticket";

      if (reset) {
        this.ticketForm.reset({
          title: "",
          description: "",
          registrant: "",
          registeredBy: 0,
          account: "",
          branchId: 0,
          statusId: 0,
          responsible: "",
          assigned: 0,
          departmentId: 0,
          accountmanager: "",
          priorityId: 0,
          date_done: null,
          durationEstimate: "",
          archived: false,
        });
      }
      this.ticketTitle = "ticketDetails.title.new.ticket";
    } else if ("edit" === nav.action) {
      this.ticketTitle = "ticketDetails.title.exist.ticket";
      this.editMode = true;
    } else {
      this.editMode = false;
    }
  }

  private initializeForm(): void {
    this.ticketForm = this.fb.group({
      title: "",
      description: "",
      registrant: "",
      registeredBy: 0,
      account: "",
      branchId: 0,
      statusId: 0,
      responsible: "",
      assigned: 0,
      departmentId: 0,
      accountmanager: "",
      priorityId: 0,
      date_done: null,
      durationEstimate: "",
      archived: false,
    });
  }

  TicketEmpty(): boolean {
    const ticketValue = this.ticket.value;
    return (
      (!ticketValue || ticketValue.id === null || ticketValue.id === 0) &&
      !this.editMode
    );
  }

  private populateForm(ticket: Ticket): void {
    if (ticket.id) {
      this.ticket.next(ticket);
      this.populateFormWithCurrentTicket();
    } else {
      this.populateFormWithTicket(ticket);
    }
  }

  private populateFormWithCurrentTicket(): void {
    const ticket = this.ticket.value;
    this.populateFormWithTicket(ticket);
  }
  private populateFormWithTicket(
    ticket: Ticket,
    emit: boolean = false,
    form?: FormGroup<any>
  ): void {
    const processing = form || this.ticketForm;
    processing.setValue(
      {
        title: ticket.title,
        description: ticket.description,
        registrant: ticket.registrant,
        registeredBy: ticket.registeredBy,
        account: ticket.account,
        branchId: ticket.branchId,
        statusId: ticket.statusId ?? null,
        responsible: ticket.responsible,
        assigned: ticket.assigned,
        departmentId: ticket.departmentId,
        accountmanager: ticket.accountmanager,
        priorityId: ticket.priorityId ?? null,
        date_done: ticket.date_done ?? null,
        durationEstimate: ticket.durationEstimate,
        archived: ticket.archived,
      },
      { emitEvent: emit, onlySelf: false }
    );

    this.editOrNot();
    this.ticketTitle = this.editMode
      ? "ticketDetails.title.new.ticket"
      : "ticketDetails.title.exist.ticket";

    return processing.value;
  }

  toggleEditMode() {
    const ticketId = this.ticket.value.id;

    if (this.editMode) {
      this.router.navigate(["/tickets", ticketId]);
      this.editMode = false;
      this.nav.freshNavigation;
    } else {
      this.router.navigate(["/tickets", ticketId, "edit"]).then(() => {
        this.ticketService.selectFromRouter();

        this.editMode = true;
      });
    }
  }

  saveTicket(action: ActionButtonSubmit): void {
    this.isLoading = true;
    this.messages.next(Messages.EMPTY);
    if (this.ticketForm.valid) {
      const token = this.auth.token;
      const dateDone = this.ticketForm.value.date_done;

      if (dateDone && new Date(dateDone).getTime() < new Date().getTime()) {
        this.ticketForm.patchValue({
          date_done: null,
        });
      }

      const id = this.ticket.value.id;
      const updatedTicket = new Ticket(
        id === null || id < 1 ? Navigation.NEW : id,
        this.ticketForm.value.title || "",
        this.ticketForm.value.description || "",
        this.ticketForm.value.registrant || "",
        this.ticketForm.value.registeredBy || 0,
        this.ticketForm.value.account || "",
        this.ticketForm.value.branchId || 0,
        this.ticketForm.value.statusId || 0,
        this.ticketForm.value.responsible || "",
        this.ticketForm.value.assigned || 0,
        this.ticketForm.value.departmentId || 0,
        this.ticketForm.value.accountmanager || "",
        this.ticketForm.value.priorityId || 0,
        this.ticketForm.value.date_done || null,
        this.ticketForm.value.durationEstimate || "",
        this.ticketForm.value.archived || false
      );

      if (this.nav.currentId === "-9") {
        this.ticketService
          .createTicket(token, updatedTicket)
          .subscribe((messages) => {
            if (messages.hasAnyMessages) {
              this.isLoading = false;
              this.messages.next(messages);
              action.result(false);
            } else {
              const newTicketId = this.ticketService.currentTicket?.id;
              if (newTicketId) {
                this.ticketService
                  .getTicketWithParts(token, newTicketId)
                  .subscribe((getMessages) => {
                    this.receiveTicket(getMessages, action, token);
                  });
              }
            }
          });

        this.ticketTitle = "ticketDetails.title.exist.ticket";
      } else {
        // edição
        this.ticketService
          .updateTicket(token, updatedTicket)
          .subscribe((messages) => {
            if (messages.hasAnyMessages) {
              this.isLoading = false;
              this.messages.next(messages);
              action.result(false);
            } else {
              const updatedTicketId =
                this.ticketService.currentTicket?.id || updatedTicket.id;
              if (updatedTicketId) {
                this.ticketService
                  .getTicketWithParts(token, updatedTicketId)
                  .subscribe((getMessages) => {
                    this.receiveTicket(getMessages, action, token);
                  });
              }
            }
          });
      }
    }
  }
  receiveTicket(messages: Messages, action: ActionButtonSubmit, token: string) {
    this.isLoading = false;
    this.messages.next(messages);

    if (messages.hasAnyMessages) {
      action.result(false);
    } else {
      action.result(true);
      this.ticketService.clearFormStateBackup();
      this.updateTicketList(token);

      const newTicketId = this.ticketService.currentTicket?.id;

      if (newTicketId && newTicketId > 0) {
        this.nav.clearNavigationState();
   
let currentTab = "comment";
switch (this.selectedIndex) {
  case 0:
    currentTab = "comment";
    break;
  case 1:
    currentTab = "media";
    break;
  case 2:
    currentTab = "involved";
    break;
  case 3:
    currentTab = "timeline";
    break;
}

this.router
  .navigate([`/tickets/${newTicketId}/fragmentedit/${currentTab}/-9`])
  .then(() => {
    this.editMode = false;
    this.isCreating = false;
  });

      }
    }
  }

  private updateTicket(ticket: Ticket): Ticket {
    const id = this.ticket.value.id;
    ticket.id = id;
    ticket.title = this.ticketForm.value.title || "";
    ticket.description = this.ticketForm.value.description || "";
    ticket.registrant = this.ticketForm.value.registrant || "";
    ticket.registeredBy = this.ticketForm.value.registeredBy || 0;
    ticket.account = this.ticketForm.value.account || "";
    ticket.branchId = this.ticketForm.value.branchId || 0;
    ticket.statusId = this.ticketForm.value.statusId || 0;
    ticket.responsible = this.ticketForm.value.responsible || "";
    ticket.assigned = this.ticketForm.value.assigned || 0;

    ticket.departmentId = this.ticketForm.value.departmentId || 0;
    ticket.accountmanager = this.ticketForm.value.accountmanager || "";
    ticket.priorityId = this.ticketForm.value.priorityId || 0;
    ticket.date_done = this.ticketForm.value.date_done || null;
    ticket.durationEstimate = this.ticketForm.value.durationEstimate || "";
    ticket.archived = this.ticketForm.value.archived || false;
    return ticket;
  }

  private get updatedExistingTicket(): Ticket {
    const existingTicket = this.ticket.value;
    return this.updateTicket(existingTicket);
  }

  deleteTicket(): void {
    const token = this.auth.token;
    const id = this.ticket.value.id;

    if (id) {
      this.ticketService.deleteTicket(token, id).subscribe(
        (messages) => {
          this.messages.next(messages);
          this.router.navigate(["tickets"]);
          this.updateTicketList(token);
        },
        (error) => {}
      );
    }
  }

  updateTicketList(token: string): void {
    this.ticketService.search(token).subscribe((messages) => {
      const updatedTicket = this.ticketService.ticketData;
      this.ticketService._currentTicket.next(updatedTicket);
    });
  }
  private updateTimelineView(ticket: Ticket): void {
    const view = (ticket.timeline || []).map((tl) => ({
      id: tl.id,
      ticket: tl.ticket,
      topic: tl.topic,
      reference: tl.reference,
      oldReference: tl.oldReference,
      action: tl.action,
      actor: tl.actor,
      changed: tl.changed,
      title: tl.title ?? `${tl.action} - ${tl.topic}`,
      timestamp: tl.changed,
      description: `Referência: ${tl.reference}, Tópico: ${tl.topic}`,
      type: tl.topic,
      user: tl.actor
        ? { id: tl.actor, name: `Usuário #${tl.actor}` }
        : undefined,
    }));
    this.timelineView.next(view);
    this.showTimeline();
  }

  relaySingleChoice(choice: SingleChoice) {
    this.disableEditingDuringChoice = true;
    this.ticketService.setFormState(this.ticketForm.value);
    this.nav.startChoice(choice);
  }

  get branchIdObserver(): Partial<Observer<number>> {
    return {
      next: (id) => {
        this.onBranchChoice(id);
      },
    };
  }

  onBranchChoice(branchId: number): void {
    const current = this.populateAndSynchonize(this.ticket.value);
    current.branchId = branchId;
    this.ticketForm.patchValue({
      branchId: branchId,
    });
  }
  get statusIdObserver(): Partial<Observer<number>> {
    return {
      next: (id) => {
        this.onStatusChoice(id);
      },
    };
  }
  onStatusChoice(statusId: number): void {
    const current = this.populateAndSynchonize(this.ticket.value);
    current.statusId = statusId;

    this.ticketForm.patchValue({
      statusId: statusId,
    });
  }
  get priorityIdObserver(): Partial<Observer<number>> {
    return {
      next: (id) => {
        this.onPriorityChoice(id);
      },
    };
  }
  onPriorityChoice(priorityId: number): void {
    const current = this.populateAndSynchonize(this.ticket.value);
    current.priorityId = priorityId;
    this.ticketForm.patchValue({
      priorityId: priorityId,
    });
  }
  get departmentIdObserver(): Partial<Observer<number>> {
    return {
      next: (id) => {
        this.onDepartmentChoice(id);
      },
    };
  }

  onDepartmentChoice(departmentId: number): void {
    this.messages.next(Messages.EMPTY);
    const current = this.populateAndSynchonize(this.ticket.value);
    current.departmentId = departmentId;
    this.ticketForm.patchValue({
      departmentId: departmentId,
    });

    this.ticket.value, this.ticketForm.value;
  }

  private populateAndSynchonize(current: Ticket): Ticket {
    this.populateFormWithCurrentTicket();
    const state = this.ticketService.restoreFormState(false);
    this.populateFormWithTicket(state as Ticket, true, this.ticketForm);
    this.editMode = true;
    const updated = this.updateTicket(current);
    this.disableEditingDuringChoice = false;

    return updated;
  }
  get assignedIdObserver(): Partial<Observer<number>> {
    return {
      next: (id) => {
        this.onAssignedChoice(id);
      },
    };
  }
  onAssignedChoice(assignedId: number): void {
    const current = this.populateAndSynchonize(this.ticket.value);
    current.assigned = assignedId;

    this.ticketForm.patchValue({
      assigned: assignedId,
    });
  }

  getIcon(type: string): string {
    return this.iconMap[type] || "help_outline";
  }
  get ticketId(): number {
    const ticket = this.ticket.value;
    return ticket && ticket.id ? ticket.id : Navigation.NEW;
  }
  get branchId(): number {
    const ticket = this.ticket.value;

    return ticket && ticket.branchId ? ticket.branchId : -1;
  }

  get branchLabel(): string {
    const id = this.branchId;

    let label = "-";
    if (id > 1) {
      const partId = this.ticket.value?.parts?.branch?.id;
      if (id === partId) {
        label = this.ticket.value.parts.branch.name;
      } else {
        label = this.branches.labelForId(id);
      }
    }
    return label;
  }
  get branchLabelerByService(): Labeler {
    return this.branches;
  }

  get statusId(): number {
    const ticket = this.ticket.value;
    return ticket && ticket.statusId ? ticket.statusId : -1;
  }

  get statusLabel(): string {
    const id = this.statusId;
    let label = "--";
    if (id > 0) {
      const partId = this.ticket.value?.parts?.status?.id;
      if (id === partId) {
        label = this.ticket.value.parts.status.name;
      } else {
        label = this.status.labelForId(id);
      }
    }
    return label;
  }

  get statusLabelerByService(): Labeler {
    return this.status;
  }

  get priorityId(): number {
    const ticket = this.ticket.value;
    return ticket && ticket.priorityId ? ticket.priorityId : -1;
  }

  get priorityLabel(): string {
    const id = this.priorityId;

    let label = "--";
    if (id > 0) {
      const partId = this.ticket.value?.parts?.priority?.id;
      if (id === partId) {
        label = this.ticket.value.parts.priority.value;
      } else {
        label = this.priority.labelForId(id);
      }
    }
    return label;
  }
  get priorityLabelerByService(): Labeler {
    return this.priority;
  }

  get departmentId(): number {
    const ticket = this.ticket.value;
    return ticket && ticket.departmentId ? ticket.departmentId : -1;
  }

  get departmentLabel(): string {
    const id = this.departmentId;

    let label = "--";
    if (id > 1) {
      const partId = this.ticket.value?.parts?.department?.id;
      if (id === partId) {
        label = this.ticket.value.parts.department.name;
      } else {
        label = this.department.labelForId(id);
      }
    }
    return label;
  }
  get departmentLabelerByService(): Labeler {
    return this.department;
  }

  get assignedId(): number {
    const ticket = this.ticket.value;
    return ticket && ticket.assigned ? ticket.assigned : -1;
  }

  get assignedLabel(): string {
    const id = this.assignedId;

    let label = "-";
    if (id > 1) {
      const partId = this.ticket.value?.parts?.assigned?.id;
      if (id === partId) {
        label = this.ticket.value.parts.assigned.name;
      } else {
        label = this.assigned.labelForId(id);
      }
    }
    return label;
  }
  get assignedLabelerByService(): Labeler {
    return this.assigned;
  }
  get TRUE(): boolean {
    return true;
  }
  get FALSE(): boolean {
    return false;
  }

  get isCreatingMode(): boolean {
    return !this.editMode;
  }
}
